import CommentSection from './components/CommentsSection';
import './scss/main.scss';


function App() {
  return (
    
    <CommentSection currentUser='juliusomo'/>
  );
}

export default App;
